import { messages } from './index';
import { flattenMessages } from './flattenMessages';

const flatCache = {};

/**
 * Look up a translated message by key for the given locale.
 * Designed for use outside React context (e.g. Redux thunks).
 */
export function getMessage(locale, key) {
  if (!flatCache['en-US']) {
    flatCache['en-US'] = flattenMessages(messages['en-US']);
  }
  if (!flatCache[locale]) {
    flatCache[locale] = flattenMessages(messages[locale] || messages['en-US']);
  }
  return flatCache[locale][key] || flatCache['en-US'][key] || key;
}
